import { render, staticRenderFns } from "./h-setting-nav.vue?vue&type=template&id=1a86b37a&"
import script from "./h-setting-nav.vue?vue&type=script&lang=js&"
export * from "./h-setting-nav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports